import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PasswordChange } from '../password-change';
import { PasswordRecoveryService } from '../password-recovery.service';
import { faUser, faLock, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {

  @ViewChild('newPasswordForm', {static: false}) newPasswordForm: any;
  success = '';
  error = '';
  passwordChange: PasswordChange = {
    token: '',
    oldPassword: '',
    newPassword: '',
    verifyPassword: '',
    username: ''
  }
  hideNewPassword = true;
  faUser = faUser;
  faLock = faLock;
  faEyeSlash = faEyeSlash;
  faEye = faEye;

  constructor(private route: ActivatedRoute,
              private passwordRecoveryService: PasswordRecoveryService) { }

  ngOnInit(): void {
    this.passwordChange.token = this.route.snapshot.queryParamMap.get("token");
    this.passwordChange.username = this.route.snapshot.queryParamMap.get("username");
    console.log(`Token=${this.passwordChange.token}`);
  }

  onPwChange(e) {
    if (this.passwordChange.newPassword && this.passwordChange.verifyPassword) {
      if (this.passwordChange.newPassword !== this.passwordChange.verifyPassword) {
        this.newPasswordForm.controls['verifyPassword'].setErrors({'mismatch': 'Passwords don\'t match'});
      }
      else {
        this.newPasswordForm.controls['verifyPassword'].updateValueAndValidity(true, true);
      }
    }
  }

  onSubmit() {
    this.error = "";
    const clonedPasswordChange = Object.assign({}, this.passwordChange);
    if (!this.hideNewPassword) {
      clonedPasswordChange.verifyPassword = clonedPasswordChange.newPassword;
    }
    this.passwordRecoveryService.resetPw(clonedPasswordChange).subscribe(result => {
      this.success = result.message;
    }, error =>{
      if (error.error instanceof ErrorEvent) {
        this.error = `Error: ${error.error.message}`;
      } else {
        this.error = `Error: ${error.error}`;
      }
    });
  }

  toggleHideNewPassword() {
    this.hideNewPassword = !this.hideNewPassword;
  }
}
